export const generateSmsMessage = (message, couple) => {
  const { name, spouse } = couple;
  return message.replace('[NAME]', name).replace('[PARTNER]', spouse);
};
